import React from "react";
import { motion } from "framer-motion";
import {
  Cpu, Landmark, HardHat, Stethoscope, ConciergeBell, ShoppingBag, Truck, TrendingUp, Building2,
} from "lucide-react";
import { SectionLabel } from "./Shared";
import { INDUSTRIES } from "../config/siteConfig";
import { stagger, fadeUp, viewportOnce } from "../lib/motion";

const ICONS = { Cpu, Landmark, HardHat, Stethoscope, ConciergeBell, ShoppingBag, Truck, TrendingUp, Building2 };

export const Industries = () => (
  <section id="industries" className="bg-white py-24 md:py-36" data-testid="industries-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      {/* Marquee strip */}
      <div className="overflow-hidden mb-16 border-y border-black/10 py-5">
        <div className="marquee-track gap-12">
          {[...INDUSTRIES, ...INDUSTRIES].map((it, i) => (
            <span key={i} className="font-display text-2xl md:text-3xl text-[#111111]/25 whitespace-nowrap flex items-center gap-12">
              {it.name} <span className="text-[#C62828] text-lg">/</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-3xl mb-14">
        <SectionLabel>Sectors We Serve</SectionLabel>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-[#111111]">
          Specialist Talent Across <span className="text-[#C62828]">Key Industries.</span>
        </h2>
      </div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5"
      >
        {INDUSTRIES.map((it) => {
          const Icon = ICONS[it.icon] || Building2;
          return (
            <motion.div
              key={it.name}
              variants={fadeUp}
              data-testid={`industry-${it.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group flex items-start gap-5 p-7 border border-black/10 rounded-sm hover:border-[#C62828] hover:shadow-[0_18px_40px_-24px_rgba(198,40,40,0.5)] transition-all duration-400"
            >
              <span className="flex-shrink-0 w-12 h-12 rounded-sm bg-[#F7F7F5] flex items-center justify-center group-hover:bg-[#C62828] transition-colors duration-400">
                <Icon size={22} strokeWidth={1.5} className="text-[#C62828] group-hover:text-white transition-colors" />
              </span>
              <div>
                <h3 className="font-body font-600 text-lg text-[#111111]">{it.name}</h3>
                <p className="font-body text-[#555] text-sm mt-1 leading-relaxed">{it.desc}</p>
              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);

export default Industries;
